interface PlatformBadgeProps {
  platform: string;
}

export default function PlatformBadge({ platform }: PlatformBadgeProps) {
  const isGoogle = platform === 'google_ads';
  const isMeta = platform === 'meta_ads';

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
        isGoogle
          ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400'
          : isMeta
            ? 'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-400'
            : 'bg-stone-100 dark:bg-stone-800 text-stone-600 dark:text-stone-400'
      }`}
    >
      {isGoogle ? 'Google' : isMeta ? 'Meta' : platform}
    </span>
  );
}
